// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#cx-main {
  transition: all 0.5s;
  padding: 80px 20px 20px 20px;
  background: linear-gradient(120deg, rgba(0, 126, 204, 0.3411764706) 0%, rgba(236, 0, 140, 0.2509803922) 100%);
  min-height: calc(100vh - 60px);
  min-height: 100vh;
  margin-left: 250px;
}

.cx-active {
  margin-left: 60px !important;
  transition: all 0.5s;
}

.cx-header-wrapper.cx-active {
  width: calc(100% - 60px) !important;
  margin-left: 60px !important;
}

.btn-slide {
  background: #00bfb6;
  position: relative;
  /* Right Slider */
}
.btn-slide .btn {
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  z-index: 1;
  transition: all 1s ease;
  width: 200px;
  height: 50px;
  line-height: 50px;
  border: 2px solid #fff;
  margin: 30px 0;
  position: relative;
  cursor: pointer;
  transition: all 1s ease;
  overflow: hidden;
}
.btn-slide .btn:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  transition: all 1s ease;
}
.btn-slide .btn-2:before {
  top: 0;
  left: -210px;
}
.btn-slide .btn-1:before {
  top: 0;
  left: 210px;
}
.btn-slide .btn1-active::before {
  left: 0;
}
.btn-slide .btn2-active::before {
  left: 0;
}

.paginationBttns {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: end;
  list-style: none;
  right: 20px;
}

.paginationBttns a {
  padding: 6px 10px 6px 10px;
  margin-left: 10px;
  border-radius: 5px;
  border: 1px solid #53B7E8;
  color: #53B7E8 !important;
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
}

.paginationBttns a:hover {
  color: white !important;
  background-color: #53B7E8;
}

.paginationActive a {
  color: white !important;
  background-color: #53B7E8;
}

@media all and (max-width: 768px) {
  .paginationBttns li {
    margin-bottom: 20px !important;
  }
}
.page-numbers {
  margin-left: 20px !important;
}

.active-pageno {
  color: #0d6efd !important;
}

.paginate {
  display: flex;
  justify-content: end;
  align-items: center;
  flex: initial;
}

.nextBtn {
  text-align: start;
}

.preBtn {
  text-align: end;
}

.pagenationBtn {
  margin-left: 30px;
}

.pagenationBtn button {
  padding: 0 15px;
}

.verticle-line {
  color: black;
  height: 15px !important;
  width: 2px;
  margin-top: 4px;
  top: -5px;
  background-color: currentColor;
  border: 0;
  opacity: 0.25;
  display: block;
  margin: inherit;
}

.pagination-wrapper .pagination {
  color: #055d9d;
}

#pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: #dee2e6;
  --bs-pagination-border-radius: 0.375rem;
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: #e9ecef;
  --bs-pagination-hover-border-color: #dee2e6;
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: #e9ecef;
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: #6c757d;
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: #dee2e6;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/style.scss","webpack://./src/assets/styles/paginate.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,4BAAA;EACA,6GAAA;EACE,8BAAA;EACF,iBAAA;EACA,kBAAA;ACCF;;ADCA;EACE,4BAAA;EACA,oBAAA;ACEF;;ADCA;EACE,mCAAA;EACA,4BAAA;ACEF;;ADEA;EACE,mBAAA;EACA,kBAAA;EAmCA,iBAAA;ACjCF;ADDE;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;ACGJ;ADAE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;ACEJ;ADCE;EACE,MAAA;EACA,YAAA;ACCJ;ADGE;EACE,MAAA;EACA,WAAA;ACDJ;ADiBE;EACE,OAAA;ACfJ;ADiBE;EACE,OAAA;ACfJ;;AA7DA;EACE,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EAGA,WAAA;AA8DF;;AA3DA;EACE,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AA8DF;;AA3DA;EACE,uBAAA;EACA,yBAAA;AA8DF;;AA3DA;EACE,uBAAA;EACA,yBAAA;AA8DF;;AA3DA;EAEI;IACE,8BAAA;EA6DJ;AACF;AAxDA;EACE,4BAAA;AA0DF;;AAvDA;EACE,yBAAA;AA0DF;;AAvDA;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;AA0DF;;AAvDA;EACE,iBAAA;AA0DF;;AAvDA;EACE,eAAA;AA0DF;;AAxDA;EACE,iBAAA;AA2DF;;AAzDA;EACE,eAAA;AA4DF;;AAzDA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EAEA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AA2DF;;AAxDA;EACE,cAAA;AA2DF;;AAxDA;EACE,kCAAA;EACA,mCAAA;EACA,+BAAA;EACA,2CAAA;EACA,wBAAA;EACA,iCAAA;EACA,qCAAA;EACA,uCAAA;EACA,uDAAA;EACA,iCAAA;EACA,2CAAA;EACA,uDAAA;EACA,iCAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,uCAAA;EACA,iCAAA;EACA,8CAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AA2DF;;AAvDA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EACA,yCAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EACA,qIAAA;AA0DF","sourcesContent":["#cx-main {\n  transition: all 0.5s;\n  padding: 80px 20px 20px 20px;\n  background: linear-gradient(120deg, #007ecc57 0%, #ec008c40 100%);\n    min-height: calc(100vh - 60px);\n  min-height: 100vh;\n  margin-left: 250px;\n}\n.cx-active {\n  margin-left: 60px !important;\n  transition: all 0.5s;\n\n}\n.cx-header-wrapper.cx-active {\n  width: calc(100% - 60px) !important;\n  margin-left: 60px !important;\n\n}\n\n.btn-slide {\n  background: #00bfb6;\n  position: relative;\n  .btn {\n    text-align: center;\n    text-transform: uppercase;\n    color: #fff;\n    font-weight: bold;\n    font-size: 16px;\n    position: relative;\n    z-index: 1;\n    transition: all 1s ease;\n    width: 200px;\n    height: 50px;\n    line-height: 50px;\n    border: 2px solid #fff;\n    margin: 30px 0;\n    position: relative;\n    cursor: pointer;\n    transition: all 1s ease;\n    overflow: hidden;\n  }\n\n  .btn:before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n    position: absolute;\n    transition: all 1s ease;\n\n  }\n  .btn-2:before {\n    top: 0;\n    left: -210px;\n  }\n\n  /* Right Slider */\n  .btn-1:before {\n    top: 0;\n    left: 210px;\n  }\n\n  // .btn:hover {\n  //   color: #00bfb6 ;\n  // }\n\n  // .btn-2:hover::before,\n  // .btn-1:hover::before {\n  //   left: 0;\n  // }\n\n\n  label {\n  }\n\n  .btn1-active::before {\n    left: 0;\n  }\n  .btn2-active::before {\n    left: 0;\n  }\n}\n\n","@import \"style.scss\";\n\n\n.paginationBttns {\n  display: flex !important;\n  flex-wrap: wrap;\n  justify-content: end;\n  list-style: none;\n  // position: absolute;\n  // bottom: 15px;\n  right: 20px;\n}\n\n.paginationBttns a {\n  padding: 6px 10px 6px 10px;\n  margin-left: 10px;\n  border-radius: 5px;\n  border: 1px solid #53B7E8;\n  color: #53B7E8 !important;\n  font-size: 13px;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.paginationBttns a:hover {\n  color: white !important;\n  background-color: #53B7E8;\n}\n\n.paginationActive a {\n  color: white !important;\n  background-color: #53B7E8;\n}\n\n@media all and (max-width: 768px) {\n  .paginationBttns {\n    li {\n      margin-bottom: 20px !important;\n    }\n  }\n}\n\n\n.page-numbers {\n  margin-left: 20px !important;\n}\n\n.active-pageno {\n  color:  #0d6efd!important;\n}\n\n.paginate {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  flex: initial;\n}\n\n.nextBtn {\n  text-align: start;\n}\n\n.preBtn {\n  text-align: end;\n}\n.pagenationBtn {\n  margin-left: 30px;\n}\n.pagenationBtn button {\n  padding: 0 15px;\n}\n\n.verticle-line {\n  color: black;\n  height: 15px !important;\n  width: 2px;\n  margin-top: 4px;\n  top: -5px;\n\n  background-color: currentColor;\n  border: 0;\n  opacity: 0.25;\n  display: block;\n  margin: inherit;\n}\n\n.pagination-wrapper .pagination {\n  color: #055d9d;\n}\n\n#pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: #fff;\n  --bs-pagination-border-width: 1px;\n  --bs-pagination-border-color: #dee2e6;\n  --bs-pagination-border-radius: 0.375rem;\n  --bs-pagination-hover-color: var(--bs-link-hover-color);\n  --bs-pagination-hover-bg: #e9ecef;\n  --bs-pagination-hover-border-color: #dee2e6;\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: #e9ecef;\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #0d6efd;\n  --bs-pagination-active-border-color: #0d6efd;\n  --bs-pagination-disabled-color: #6c757d;\n  --bs-pagination-disabled-bg: #fff;\n  --bs-pagination-disabled-border-color: #dee2e6;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
